/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionendconfirmbody3Inputs */

const en_actionendconfirmbody3 = /** @type {(inputs: Actionendconfirmbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It disappears from your place page and the feed. A push that went out stays sent.`)
};

const de_actionendconfirmbody3 = /** @type {(inputs: Actionendconfirmbody3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie verschwindet von deiner Ortsseite und aus dem Feed. Eine verschickte Mitteilung bleibt verschickt.`)
};

/**
* | output |
* | --- |
* | "It disappears from your place page and the feed. A push that went out stays sent." |
*
* @param {Actionendconfirmbody3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionendconfirmbody3 = /** @type {((inputs?: Actionendconfirmbody3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionendconfirmbody3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionendconfirmbody3(inputs)
	return de_actionendconfirmbody3(inputs)
});
export { actionendconfirmbody3 as "actionEndConfirmBody" }